<style>
.v-carousel{width:100%;position:relative}
.v-carousel{overflow:hidden}
.v-carousel-items{overflow:hidden}
.v-carousel-dots{position:absolute;bottom:10px;left:0;width:100%;text-align:center}
.v-carousel-dot{cursor:pointer;display:inline-block;width:10px;height:10px;margin:0 5px;border-radius:5px;background:rgba(0,0,0,.5)}
.v-carousel-dot.active{background:#000;cursor:default}
.v-carousel-nav{cursor:pointer;position:absolute;line-height:30px;color:#fff;padding:0 5px;background:rgba(0,0,0,.5);top:50%;margin-top:-15px;display:none;}
.v-carousel-nav.prev{left:0}
.v-carousel-nav.next{right:0}
.v-carousel-item{width:100%;float:left}
</style>

<template lang="html">
  <div class="uk-margin-top">
    <div class="uk-flex uk-flex-wrap">
      <div id="visit-notifications" class="uk-width-1-2@m">
        <h4>Wyślij wiadomość</h4>
        <div class="uk-margin uk-width-3-4@m">
          <textarea v-model="messageTxt" class="uk-textarea" rows="5" placeholder="Wpisz wiadomość" id="messageInp"></textarea>

          <div class="uk-margin" id="selectedFiles">
            <div v-for="(file, key) in files" class="file-listing">
              {{ file.name }}
              <span style="cursor:pointer;" class="uk-label uk-label-danger" v-on:click="removeFile( key )">Usuń</span>
            </div>
          </div>

          <div class="uk-margin">
            <div uk-form-custom>
              <input type="file" id="files" ref="files" multiple v-on:change="handleFileUpload()">
              <button class="uk-button uk-button-primary" type="button" tabindex="-1">Dodaj załączniki</button>
            </div>
            <button v-on:click="submitForm()" :disabled="this.messageTxt.length <= 0" class="uk-button uk-button-primary">Wyślij</button>
          </div>

        </div>
      </div>

      <div id="visit-documents" class="uk-width-1-2@m uk-overflow-auto">
        <h4></h4>
        <carousel :auto="5000" :watch-items="list">
          <carousel-item v-for="(item, index) in list" :key="item.url">
              <img v-bind:src="item.url" />
          </carousel-item>
        </carousel>
      </div>

      <div id="visit-questionnaire" class="uk-width-2-2@m uk-margin-top">
        <h4 style="margin-top:0px !important;">Nazwa i adresy kliniki oraz informację</h4>
        <p><b>Nazwa kliniki:</b> {{ config.clinic_info.name }}</p>
        <p><b>Adres:</b> {{ config.clinic_info.street }}, {{ config.clinic_info.postal_code }}, {{ config.clinic_info.city }}</p>
        <p><b>Opis:</b> {{ config.clinic_info.description }}</p>
      </div>

    </div>

  </div>
</template>

<script>
import { Carousel, CarouselItem } from 'vue-l-carousel'
import $ from 'jquery'
import UIkit from 'uikit'
var getDomain = location.protocol + '//' + location.host
export default {
  beforeMount () {
    // Slider

    this.$http.post(getDomain + '/slider.php?number=2').then(response => {
      let images = Object.values(response.data).map(x => { return { url: `${getDomain}/slider2/${x}` } })
      this.list = images
    })
  },
  data () {
    return {
      'firstName': '',
      'LastName': '',
      'email': '',
      auto: 5000,
      dots: true,
      list: [],
      files: [],
      messageTxt: '',
      contactMail: '',
      contactFromMail: ''
    }
  },
  computed: {
    config () {
      return this.$parent.config
    }
  },
  components: {
    'carousel': Carousel,
    'carousel-item': CarouselItem
  },
  mounted: function () {
    $('#sliderMain').css('display', 'none')
    $('#backbtn').css('display', 'none')
    $('#notifications').css('display', 'none')
    $('.session-info-wrap').css('width', '100%')
    if (this.$cookie.get('cdata')) {
      this.firstName = $.parseJSON(this.$cookie.get('cdata')).name
      this.LastName = $.parseJSON(this.$cookie.get('cdata')).lastname
      this.email = $.parseJSON(this.$cookie.get('cdata')).email
    }
    this.$http.get(getDomain + '/config.php').then((response) => {
      var resp = response.data
      this.contactMail = resp.emailZzalacznikiemAdres
      this.contactFromMail = resp.emailZzalacznikiemFrom
    }).catch((errors) => {
      JSON.stringify(errors)
    })
  },
  methods: {
    submitForm () {
      let formData = new FormData()
      formData.append('recipient', this.contactMail)
      formData.append('from', this.contactFromMail)
      formData.append('text', this.messageTxt)
      formData.append('unison_id', localStorage.getItem('unison_id'))
      // formData.append('sender', this.firstName + ' ' + this.LastName)
      formData.append('sender', 'Portal pacjenta')
      formData.append('email', this.email)
      // Jeśli dodany plik to wysyłamy na mail jeśli nie to wiadomość do Unison
      if (this.files.length === 0) {
        var token = this.$cookie.get('aut')
        var id = $.parseJSON(this.$cookie.get('cdata')).id
        var newContact = { 'input': { 'messagetxt': this.messageTxt, 'data': { 'TOKEN': token, 'id': id } } }
        this.$http.post('/api.php?url=addNewContact', newContact, {headers: {'Content-Type': 'application/json'}}).then((response) => {
          if (response.status === 200 && response.body.d.status === 'OK') {
            UIkit.modal.alert('Wiadomość została wysłana. Dziękujemy.')
            this.files.splice(0, this.files.length)
            this.messageTxt = ''
          } else {
            UIkit.modal.alert('Coś poszło nie tak... Spróbuj później')
          }
        }).catch((errors) => {
          UIkit.modal.alert('Coś poszło nie tak... Spróbuj później')
          console.error(errors)
        })
      } else {
        for (var i = 0; i < this.files.length; i++) {
          let file = this.files[i]
          formData.append('files[' + i + ']', file)
        }
        this.$http.post(getDomain + '/message.php', formData, {headers: {'Content-Type': 'multipart/form-data'}}).then((response) => {
          UIkit.modal.alert('Wiadomość została wysłana. Dziękujemy.')
          this.files.splice(0, this.files.length)
          this.messageTxt = ''
        }).catch((errors) => {
          UIkit.modal.alert('Coś poszło nie tak... Spróbuj jeszcze raz')
        })
      }
    },
    handleFileUpload () {
      let uploadedFiles = this.$refs.files.files
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i])
      }
    },
    removeFile (key) {
      this.files.splice(key, 1)
    }
  }
}
</script>
<style lang="sass" scoped>

  .table-holder
    max-height: 400px
    overflow-y: scroll

  .func-btn
    width: 40px
    padding: 0 10px

  tr
    cursor: pointer

  .see-more-btn

    @media screen and (max-width: 555px)
      height: 50px

    @media screen and (max-width: 430px)
      height: 71px

</style>



// WEBPACK FOOTER //
// Contact.vue?7cb2c1a6